import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import WidgetComponent from "../../Statistics/WidgetComponent";
import { Loader } from "@vds/loaders";

const StatisticsWidget = ({ state }) => {
  const [showLoader,setShowLoader] = useState(true);
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
    const host = window.REACT_APP_KNOWI_HOST;
  let ApplicationId = state?.applicationId;

  const { tagIdList } = useSelector((state) => state?.sitesReducer);
  
  const knowiFullllWidgetList = useSelector(
    (state) => state.statisticsReducer.widgets
  );
  const widgetToFilter =
    knowiFullllWidgetList?.filter((m) => {
      if (ApplicationId == "ParkingBayOccupancy") {
        return (
          m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 &&
          m?.name.indexOf("oa_") > -1 &&
          m?.name.indexOf("EInfo_") > -1
        );
      } else {
        return (
          m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 &&
          m?.name.indexOf("EInfo_") > -1
        );
      }
    }) ?? [];
  const roiList = useSelector((state) => {
    return state.deviceReducer.roiList;
  });

  const appRoi = roiList?.find((m) => {
    return (
      m?.deployments != undefined &&
      m?.deployments
        ?.map((cv) => {
          return cv.id;
        })
        .indexOf(state?.incident?.depId) > -1
    );
  });

  let locatinTagId = state?.ruleConfig?.alertLocation && state?.ruleConfig?.alertLocation[0];
  
  const getparkingCOunt = tagIdList.find((f) => {
    return f.id == locatinTagId;
  })?.parkingcount;
  
  const getStartDate = (createdAt) => {
    const tenMinutesBefore = new Date(
      new Date(createdAt ?? Date.now()).getTime() - 10 * 60 * 1000
    );
    tenMinutesBefore.setSeconds(0);
    tenMinutesBefore.setMilliseconds(0);
    return tenMinutesBefore.toISOString();
  };

  const getExtendedEndDate = () => {
    const extendedStartDate = new Date(state?.createdAt ? state.createdAt: new Date());
    extendedStartDate.setSeconds(0);
    const extendedDate = moment(extendedStartDate).add(9, "m").toDate();
    const diffInSeconds = (new Date() - extendedStartDate) / 1000;

    return {
      comparedExtendedDate: diffInSeconds >= 540 ? extendedDate : new Date(),
      extendedstatus: diffInSeconds < 540,
      extendedStartDate: extendedStartDate
    };
  };

  const buildTagIdList = () => "id~" + locatinTagId + "=name~" + "location=maxParkings~" + getparkingCOunt + "=virtualId~" + locatinTagId;
  // tagIdList/tagIdListOA/tagIdListEE are intentionally identical: the tag is location-based, not app-type-based
  const [encryptPayload, setEncryptPayload] = useState({
    accountname: activeSession?.accountId,
    tagid: locatinTagId,
    startDate: getStartDate(state?.createdAt),
    histogram_fixedinterval: "1m",
    endDate: new Date(
      moment(new Date(getExtendedEndDate().comparedExtendedDate ?? moment(new Date()))).add(1, "m")
    ).toISOString(),
    extendedendDate: getExtendedEndDate().comparedExtendedDate.toISOString(),
    getTagsKind: "ts.tag.floor",
    xAxisDateFormat: "hh:mmA",
    eventfield: "fields." + ApplicationId + ".count",
    eventfieldForPriority: "fields." +ApplicationId+".priority",
    tagIdList: buildTagIdList(),
    tagIdListOA: buildTagIdList(),
    tagIdListEE: buildTagIdList(),
  });

  useEffect(() => {
    setEncryptPayload((prev) => ({
      ...prev,
      startDate: getStartDate(state?.createdAt),
    }));
  }, [state?.createdAt]);

  useEffect(() => {
    // Set a timeout to change the state after a delay (e.g., 3000 milliseconds or 3 seconds)
    const timer = setTimeout(() => {
      setShowLoader(false);
      console.log("showing stop loader");
    }, 1000);

    // Cleanup function: Clear the timeout if the component unmounts before the delay finishes
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handle_Click_View_More = () => {
    console.log("Go ");
  };
  return (
    <>
    
    <img src={`${host}w/123`} hidden alt="host_url" />
    {showLoader && <Loader active={showLoader} fullscreen={false} />}
      {encryptPayload?.tagid?.length > 0 && (
        <WidgetComponent
          widgetList={widgetToFilter}
          handleOnClickView_More={handle_Click_View_More}
          showHideFilter={true}
          encryptPayload={encryptPayload}
          aggregatedCVAppCount={{}}
          selectedCVAppName={ApplicationId}
          cvAppImageName = {widgetToFilter?.length > 0 && widgetToFilter[0]?.name ? widgetToFilter[0].name.split("_")[0] : ""}
          renderedFrom={"EventInfo"}
          extendedstatus = {getExtendedEndDate().extendedstatus}
          stateCurrentValue = {state?.description}
        />
      )}
    </>
  );
};

export default StatisticsWidget;
